//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/event-details -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    custom_selections: t.unknown,
    description: t.union([t.null, t.undefined, t.string]),
    event_id: t.number,
    header_bg_color: t.union([t.null, t.undefined, t.string]),
    header_img_big: t.string,
    header_img_height_big: t.union([t.null, t.undefined, t.string]),
    header_img_height_medium: t.union([t.null, t.undefined, t.string]),
    header_img_height_small: t.union([t.null, t.undefined, t.string]),
    header_img_medium: t.string,
    header_img_small: t.string,
    header_img_under_stream_big: t.string,
    header_img_under_stream_medium: t.string,
    header_img_under_stream_small: t.string,
    id: t.number,
    is_active: t.boolean,
    is_active_details: t.boolean,
    is_active_promo: t.boolean,
    is_active_stream: t.boolean,
    layout_type: t.string,
    market_filters: t.unknown,
    name: t.union([t.null, t.undefined, t.string]),
    over_view_text: t.union([t.null, t.undefined, t.string]),
    promo_bg_color: t.union([t.null, t.undefined, t.string]),
    promo_img_big: t.string,
    promo_img_medium: t.string,
    promo_img_small: t.string,
    stream_url: t.union([t.null, t.undefined, t.string]),
    universe: t.string,
}));
export type Response200Type = Array<{
    custom_selections: unknown;
    description?: null | undefined | string;
    event_id: number;
    header_bg_color?: null | undefined | string;
    header_img_big: string;
    header_img_height_big?: null | undefined | string;
    header_img_height_medium?: null | undefined | string;
    header_img_height_small?: null | undefined | string;
    header_img_medium: string;
    header_img_small: string;
    header_img_under_stream_big: string;
    header_img_under_stream_medium: string;
    header_img_under_stream_small: string;
    id: number;
    is_active: boolean;
    is_active_details: boolean;
    is_active_promo: boolean;
    is_active_stream: boolean;
    layout_type: string;
    market_filters: unknown;
    name?: null | undefined | string;
    over_view_text?: null | undefined | string;
    promo_bg_color?: null | undefined | string;
    promo_img_big: string;
    promo_img_medium: string;
    promo_img_small: string;
    stream_url?: null | undefined | string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetEventDetailsRequest"
 */
export const openapi_website_cms_getEventDetails = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/event-details${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetEventDetailsParamsType = ParamsType;

export type OpenapiWebsiteCmsGetEventDetailsResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetEventDetailsResponse200Type = Response200Type;

export const openapiWebsiteCmsGetEventDetailsRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetEventDetailsResponseType> => {
    const response = await openapi_website_cms_getEventDetails(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetEventDetailsRequest - unhandled response ${response.status}`);
};

